import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/views/Landing.vue';
import SessionExpired from '@/views/SessionExpired.vue';
import locationId from './locationId';
import directMatch from './directMatch';
import personId from './personId';
import store from '@/store';
import { findModule } from '@/stores/appModule';

Vue.use(Router);

export const setModule = function set(name) {
  const module = findModule(name);
  store.dispatch('appModules/SETMODULE', module);
};

export default new Router({
  mode: 'history',
  base: (() => {
    const appIndex = window.location.pathname.indexOf(process.env.BASE_URL);
    return appIndex !== -1
      ? window.location.pathname.substring(0, appIndex + process.env.BASE_URL.length)
      : process.env.BASE_URL;
  })(),
  linkActiveClass: 'is-active',
  routes: [
    ...locationId,
    ...directMatch,
    ...personId,

    {
      path: '/landing',
      name: 'landing',
      meta: {
        public: true,
        layout: 'empty',
      },
      component: Landing,
    },
    {
      name: 'home',
      path: '/',
      beforeEnter(to, from, next) {
        let defaultModule = store.getters['appModules/activeModules'][0];
        try {
          next({ name: defaultModule.landing });
        } catch (e) {
          next({ name: 'notAuthorized' });
        }
      },
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        public: true,
        layout: 'no-sidebar',
        title: `${process.env.VUE_APP_DEFAULT_TITLE}: Login`,
      },
      component: () => import(/* webpackChunkName: "account" */ '@/views/Login.vue'),
    },
    {
      path: '/sso',
      name: 'loginSso',
      meta: {
        public: true,
        layout: 'no-sidebar',
      },
      component: () => import(/* webpackChunkName: "account" */ '@/views/LoginSso.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      meta: {
        public: true,
        layout: 'no-sidebar',
        title: `${process.env.VUE_APP_DEFAULT_TITLE}: Logout`,
      },
      component: () => import(/* webpackChunkName: "account" */ '@/views/Logout.vue'),
    },
    {
      path: '/lostpassword',
      name: 'lostpassword',
      meta: {
        public: true,
        layout: 'no-sidebar',
        title: `${process.env.VUE_APP_DEFAULT_TITLE}: Loss a Password`,
      },
      component: () => import(/* webpackChunkName: "account" */ '@/views/LostPassword.vue'),
    },
    {
      path: '/resetpassword',
      name: 'resetpassword',
      meta: {
        public: true,
        layout: 'no-sidebar',
        title: `${process.env.VUE_APP_DEFAULT_TITLE}: Reset a Password`,
      },
      component: () => import(/* webpackChunkName: "account" */ '@/views/ResetPassword.vue'),
      props: route => ({ verificationKey: route.query.verificationKey }),
    },
    {
      path: '/signup',
      name: 'signup',
      meta: {
        public: true,
        layout: 'no-sidebar',
        title: `${process.env.VUE_APP_DEFAULT_TITLE}: Create an Account`,
      },
      component: () => import(/* webpackChunkName: "account" */ '@/views/SignUp.vue'),
      props: route => ({ verificationKey: route.query.verificationKey }),
    },
    {
      path: '/sessionExpired',
      name: 'sessionExpired',
      meta: {
        public: true,
        layout: 'no-sidebar',
      },
      component: SessionExpired,
    },
    {
      path: '/notAuthorized',
      name: 'notAuthorized',
      meta: {
        public: true,
      },
      component: () => import(/* webpackChunkName: "noAuthorization" */ '@/views/NoAuthorization.vue'),
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "page-not-found" */ '@/views/PageNotFound.vue'),
      beforeEnter(to, from, next) {
        let tempModule = store.getters['appModules/activeModules'][0];
        setModule(tempModule.name);
        next();
      },
    },
  ],
});
